<template>
	<popup title="Are you sure you'd like to delete this automation?" small text-only @close="closePopup">
		<template v-slot:actions>
			<v-button @click="deleteAutomation" red border label="Delete automation" />
			<v-button @click="closePopup" label="Keep automation" />
		</template>
	</popup>
</template>

<script>
import API from "@/api"
import Popup from "@/components/base/popup";
import VButton from "@/components/base/v-button";

export default {
    name: "AutomationsDeletePopup",
	components: {VButton, Popup},
	props:['automationItem'],
    mixins: [API],
    data() {
        return {
        }
    },
    methods: {
        closePopup() {
            this.$emit("close")
        },
        deleteAutomation() {
            this.$emit("delete", this.automationItem);
        },
    },
}
</script>

<style>
    .brdr_box_w_checkbox h3 b {
        margin-right: 3px;
    }
</style>
